import React, { useEffect, useState } from "react";
import { Box, Typography, Divider, Tooltip, IconButton } from "@mui/material";
import DashboardLayout from "../../../layouts/DashboardLayout/DashboardLayout";
import PaginationTable from "../../../components/PaginationTable";
import { useLocation, useNavigate } from "react-router-dom";
import BasicButtons from "../../../components/Button";
import { toast } from "react-hot-toast";
import EditIcon from "@mui/icons-material/Edit";
import backBtn from "../../../assets/backBtn.svg";
import typographyStyles from "../../../theme/Typography";
import VisibilityIcon from "@mui/icons-material/Visibility";

import {
  deleteDataHandler,
  getDataHandlerWithToken,
  postDataHandlerWithToken,
} from "../../../apiconfig/service";
import moment from "moment";
import DataNotFound from "../../../components/DataNotFound";
import DeleteIcon from "@mui/icons-material/Delete";

const columns = [
  { id: "sr_no", label: "Sr.No." },
  { id: "title", label: "Title" },
  { id: "created_date_time", label: "Created Date & Time" },
  { id: "action", label: "Action" },
];

const ViewBlogs = () => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [blogs, setBlogsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  const fetchData = async () => {
    try {
      const response = await getDataHandlerWithToken("viewBlogByCategory", {
        categoryId: location?.state?.statisticsData?._id,
      });
      if (response?.responseCode === 200) {
        setBlogsData(response.result);
      } else {
        toast.error(response?.responseMessage || "Failed to fetch statistics");
      }
    } catch (error) {
      console.error("Error in fetching data", error);
      toast.error("Failed to fetch statistics");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleEdit = (blogs) => {
    navigate(`/staticcontent/listBlogs/viewBlogs/editBlogs`, {
      state: { blogs },
    });
  };
  const handleDelete = async (blogs) => {
    try {
      const res = await postDataHandlerWithToken("deleteBlog", {
        blogId: blogs?._id,
      });
      if (res.responseCode === 200) {
        toast.success(res.responseMessage);
        fetchData();
      } else {
        toast.error(res.data.responseMessage);
      }
    } catch (error) {
      console.error("Failed to add Blog:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClickOpen = (blogs) => {
    navigate(`/staticcontent/listBlogs/viewBlogs/viewIndividualBlogs`, {
      state: { blogs },
    });
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedRow(null);
  };

  // const handleDeleteConfirm = async () => {
  //   if (!selectedRow) return;

  //   try {
  //     const response = await deleteDataHandler("deleteStaticContent", {
  //       staticContentId: selectedRow._id,
  //     });
  //     if (response?.responseCode === 200) {
  //       toast.success("Statistic deleted successfully");
  //       setBlogssData(
  //         statisticsData.filter((item) => item._id !== selectedRow._id)
  //       );
  //     } else {
  //       toast.error(response?.responseMessage || "Failed to delete statistic");
  //     }
  //   } catch (error) {
  //     console.error("Error deleting statistic", error);
  //     toast.error("Failed to delete statistic");
  //   } finally {
  //     handleClose();
  //   }
  // };

  return (
    <DashboardLayout
      sectionName="Static Content Management"
      title="Blogs Management"
    >
      <Box className="heading-container-top">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <Box>
            <img
              src={backBtn}
              alt="backBtn"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/staticcontent/listBlogs")}
            />
          </Box>
          <Typography sx={{ ...typographyStyles.h4 }}>Blog Listing</Typography>
        </Box>
        <Box className="button-container">
          <BasicButtons
            text="+Add Blog"
            onClick={() =>
              navigate("/staticcontent/listBlogs/viewBlogs/addBlog", {
                state: { categoryId: location?.state?.statisticsData?._id },
              })
            }
          />
        </Box>
      </Box>
      <br />
      <Divider />
      <Box className="StaticScreenContainer">
        {loading ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "50vh",
            }}
          >
            {/* Add a Loading component if needed */}
          </Box>
        ) : blogs?.length < 1 ? (
          <DataNotFound />
        ) : (
          <PaginationTable
            columns={columns}
            data={blogs?.map((item, index) => ({
              sr_no: index + 1,
              title: item?.title,
              created_date_time: moment(item.createdAt).format(
                "MM/DD/YYYY, h:mm A"
              ),
              action: (
                <Box className="row-button-container">
                  <IconButton
                    onClick={() => handleClickOpen(item)}
                    sx={{ color: "rgb(225,140,168)" }}
                  >
                    <VisibilityIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleEdit(item)}
                    sx={{ color: "rgb(225,140,168)" }}
                  >
                    <EditIcon />
                  </IconButton>
                  <IconButton
                    onClick={() => handleDelete(item)}
                    sx={{ color: "rgb(225,140,168)" }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Box>
              ),
            }))}
          />
        )}
      </Box>
      {/* {open && (
        <DeleteModal
          open={open}
          handleClose={handleClose}
          handleDelete={handleDeleteConfirm}
          title="Delete Item?"
          description={`Are you sure you want to delete the statistic titled "${selectedRow?.title}"? This action cannot be undone.`}
        />
      )} */}
    </DashboardLayout>
  );
};

export default ViewBlogs;
